import React, { useMemo, useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Link, Typography } from '@material-ui/core';
import { FaCheckSquare, FaWindowClose } from 'react-icons/fa';

import DataTable from '../../../DataTable';
import useGeneralData, { GENERAL_DATA_FILTERS } from './useGeneralData';
import { format } from 'date-fns';

export default function GeneralDataCSV3({ startDate, endDate }) {
  const {
    data,
    rowsPerPage,
    isLoading,
    page,
    filters,
    changeFilters,
    changePage,
    resetFilters,
    changeRowsPerPage
  } = useGeneralData({ startDate, endDate });

  const [selectedRow, setSelectedRow] = useState(null);

  const rows = useMemo(() => {
    return data?.data?.map(row => {
      return {
        order: row?.pedidos?.length > 0 ? <Link component="button" underline="always" onClick={() => setSelectedRow(row)}>PEDIDOS</Link> : null,
        user: (
          <>
            <Typography variant="body2">{row?.name}</Typography>
            <Typography variant="caption">{row?.email}</Typography>
          </>
        ),
        registration_date: format(new Date(row?.register), 'dd/MM/yyyy'),
        paid: row?.is_paying ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />,
        pro: row?.is_pro ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />,
        mba: row?.is_mba ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />,
        doc: (
          <Box textAlign="center">
            {row?.id_doc ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}
            {row?.is_mba && !row?.id_doc && <Typography component={"a"} href={`/admin/dashboard/aluno/${row.id_pessoa}?ref=mba`} target="_blank" style={{ display: 'block' }} variant="body2">Marcar Envio</Typography>}
          </Box>
        ),
        mc: (
          <Box textAlign="center">
            {row?.has_skills_mapping ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}
            {row?.has_skills_mapping && <Typography component={'a'} href={`/admin/alunos/mapeamento-de-competencias?id_aluno=${row.id_pessoa}`} target="_blank" variant="body2" style={{ display: 'block' }}>Acessar</Typography>}
          </Box>
        ),
        ppa: (
          <Box textAlign="center">
            {row?.has_ppa ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}
            {row?.has_ppa  && <Typography component={"a"} href={`/admin/operacoes?id_aluno=${row.id_pessoa}#projetos`} target="_blank" style={{ display: 'block' }} variant="body2">Acessar</Typography>}
          </Box>
        ),
        trails: row?.has_trail ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />,
        obs: (
          <>
            <Typography title={row?.observation || "N/A"} style={{ display: 'block' }} variant="body2">
              {(row?.observation.slice(0, 50) + "...") || "N/A"}
            </Typography>
            <Typography title={row?.observation == "N/A" ? "Criar Obs" : "Editar Obs"} component={"a"} href={`/admin/alunos/detalhes/${row.id_pessoa}#observacao`} target="_blank" style={{ display: 'block' }} variant="body2">
              {row?.observation == "N/A" ? "Criar Obs" : "Editar Obs"}
            </Typography>
          </>
        )
      }
    })
  }, [data]);
  
  return (
    <Box width="100%" padding="1rem 1rem 5rem">
      <DataTable
        showFilters
        showPagination
        isLoading={isLoading}
        rowsPerPage={rowsPerPage}
        page={page}
        totalRecords={data?.count}
        maxHeight="60vh"
        hasStickHeader
        filters={[
          { key: GENERAL_DATA_FILTERS.USER, name: 'Aluno', component: { type: 'text' } },
          { key: GENERAL_DATA_FILTERS.START_DATE, name: 'Data inicial', component: { type: 'date', defaultValue: startDate } },
          { key: GENERAL_DATA_FILTERS.END_DATE, name: 'Data final', component: { type: 'date', defaultValue: endDate } },
          { key: GENERAL_DATA_FILTERS.MBA, name: 'MBA', component: { type: 'checkbox' } },
          { key: GENERAL_DATA_FILTERS.PRO, name: 'PRO', component: { type: 'checkbox' } },
          { key: GENERAL_DATA_FILTERS.DOC, name: 'DOC', component: { type: 'checkbox' } },
          { key: GENERAL_DATA_FILTERS.PAID, name: 'Pagantes', component: { type: 'checkbox' } },
          { key: GENERAL_DATA_FILTERS.MC, name: 'Mapeamento de competências', component: { type: 'checkbox' } },
          { key: GENERAL_DATA_FILTERS.PPA, name: 'PPA', component: { type: 'checkbox' } },
          { key: GENERAL_DATA_FILTERS.TRAILS, name: 'Trilha', component: { type: 'checkbox' } },
        ]}
        selectedFilters={filters}
        columns={[
          { key: 'order', name: '' },
          { key: 'user', name: 'Aluno', isSingleLine: true, },
          { key: 'registration_date', name: 'Data Registro', isSingleLine: true,align:"center" },
          { key: 'paid', name: 'Pago', isSingleLine: true,align:"center" },
          { key: 'pro', name: 'Pro', isSingleLine: true,align:"center" },
          { key: 'mba', name: 'MBA', isSingleLine: true,align:"center" },
          { key: 'doc', name: 'Doc', isSingleLine: true,align:"center" },
          { key: 'mc', name: 'MC', isSingleLine: true,align:"center"},
          { key: 'ppa', name: 'PPA', isSingleLine: true,align:"center" },
          { key: 'trails', name: 'Trilhas', isSingleLine: true,align:"center" },
          { key: 'obs', name: 'Observação', isSingleLine: true,align:"center" }
        ]}
        rows={rows}
        onRowsPerChange={changeRowsPerPage}
        onSubmitFilters={changeFilters}
        onResetFilters={resetFilters}
        onPageChange={changePage}
        CustomToolbarElement={
          <Typography variant="h5" component="h2">Detalhamento | Alunos</Typography>
        }
      />
      <Dialog
        fullWidth
        maxWidth="md"
        open={!!selectedRow}
        onClose={() => setSelectedRow(null)}
      >
        <DialogTitle>Pedidos</DialogTitle>
        <DialogContent>
          <DataTable
            showFilters={false}
            showPagination={false}
            columns={[
              { key: 'course', name: 'Curso' },
              { key: 'price', name: 'Valor pago' },
              { key: 'installments', name: 'Parcelas' },
              { key: 'payment_method', name: 'Método' },
              { key: 'obs', name: 'Observação', isSingleLine: true, maxWidth: '200px' },
              { key: 'paid_at', name: 'Data compra' }
            ]}
            rows={
              selectedRow?.pedidos?.map(pedido => ({
                course: pedido?.curso,
                price: pedido?.amount,
                installments: pedido?.installments,
                payment_method: pedido?.payment_method,
                obs: pedido?.observation || "N/A",
                paid_at: format(new Date(pedido?.data_buy), 'dd/MM/yyyy')
              }))
            }
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}